module.exports = __webpack_public_path__ + "img/title.b24aa355.png";